import { Button, Col, Form, Row, OverlayTrigger, Tooltip} from "react-bootstrap"
import { useTranslation } from "react-i18next"
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { useEffect, useState } from "react"
import Select from "react-select"
import { useAuth } from "../auth/useAuth"

export default function UserForm({state, usertype, handleInputChange, submit, disableEnableUser, isAddingOrEditing, isRegistering}) {
    const { t } = useTranslation()
    const {clientauth} = useAuth()

    const [provinceAux, setProvinceAux] = useState({label: '', value: ''});
    const [townAux, setTownAux] = useState({label: '', value: ''});

    const [townsAux, setTownsAux] = useState([]);

    useEffect(() => {
        if(state.province !== null && state.town !== null){
            setProvinceAux(provinces.filter(province => province.value === state.province))
            setTownsAux(towns.filter(town => town.parent_value === state.province))
            setTownAux(towns.filter(town => town.value === state.town))
        }else{
            setProvinceAux(null)
            setTownAux(null)
        }
    }, [state])

    const handleSelectProvinceChange = (target)=>{
        handleInputChange({target: {name: 'province', value: target.value}})

        setProvinceAux(provinces.filter(province => province.value === target.value))
        setTownAux({label: '', value: ''})
        setTownsAux(towns.filter(town => town.parent_value === target.value))
    }

    const handleSelectTownChange = (target)=>{
        handleInputChange({target: {name: 'town', value: target.value}})
        setTownAux(towns.filter(town => town.value === target.value && target.parent_value === town.parent_value))
    }

    const handleSwitchChange = ({target}) => {
        handleInputChange({target: {name: target.name, value: target.checked}})
    }

    return (
        <Form onSubmit={submit} className="px-4 formulario">
            <Row className="my-2">
                <Col xs={12} md={6}>
                    <Form.Label>{t('admin.user.name')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='name'
                        value={state.name || ''}
                        onChange={handleInputChange}
                    />
                </Col>
                <Col xs={12} md={6}>
                    <Form.Label>{t('admin.user.phone')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='phone'
                        value={state.phone || ''}
                        onChange={handleInputChange}
                    />
                </Col>
            </Row>
            <Row className="my-2">
                <Col xs={12} md={6}>
                    <Form.Group className='form-group'>
                        <Form.Label htmlFor='province'>{t('admin.user.province')}</Form.Label>
                        <Select
                            className="form-control select"
                            name='province'
                            options={provinces.sort((a, b) => {
                                if (a.label < b.label) { return -1 }
                                if (a.label > b.label) { return 1 }
                                return 0
                            })}
                            value={provinceAux || null}
                            onChange={(e) => handleSelectProvinceChange(e)}
                        />
                        <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0 }}
                            value={state.province || ''}
                            readOnly
                        />
                    </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                    <Form.Group className='form-group'>
                        <Form.Label htmlFor='town'>{t('admin.user.town')}</Form.Label>
                        <Select
                            className="form-control select"
                            name='town'
                            options={townsAux}
                            value={townAux || null}
                            onChange={(e) => handleSelectTownChange(e)}
                        />
                        <input
                            tabIndex={-1}
                            autoComplete="off"
                            style={{ opacity: 0, height: 0 }}
                            value={state.town || ''}
                            readOnly
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="my-2">
                <Col xs={12} md={6}>
                    <Form.Label>{t('admin.user.email')} ({t('global.mandatory')})</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='email'
                        value={state.email || ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
                <Col xs={12} md={6}>
                    <Form.Label>
                        {t('admin.user.password')}{isAddingOrEditing !== "editing" ? ' (' + t('global.mandatory') + ')' : ''} &nbsp;
                        {isAddingOrEditing === 'editing' &&
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                                overlay={
                                    <Tooltip>
                                        {t('admin.user.passwordTooltip')}
                                    </Tooltip>
                                }
                                >
                                <i className="fas fa-info-circle"></i>
                            </OverlayTrigger>
                        }
                    </Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='password'
                        value={state.password || ''}
                        onChange={handleInputChange}
                        required={isAddingOrEditing !== "editing" ? true : false}
                    />
                </Col>
            </Row>
            {usertype === 'admin' || (isAddingOrEditing === 'editing' && clientauth?.id !== state?._id) ?
                <Row className="my-2">
                    {usertype === 'admin' ?
                        <Col xs={12} md={6}>
                            <Form.Group className='form-group'>
                                <Form.Label>{t('admin.user.rol')} ({t('global.mandatory')})</Form.Label>
                                <Select
                                    required
                                    className="form-control select"
                                    name='rol'
                                    options={['technical', 'breeder'].map(role => ({label: t(`admin.user.${role}`), value: role}))}
                                    defaultValue={{label: t(`admin.user.technical`), value: 'technical'}}
                                    value={{label: t(`admin.user.${state.rol}`), value: state.rol}}
                                    onChange={(selectedValue) => handleInputChange({target: {name: 'rol', value: selectedValue.value}})}
                                />
                            </Form.Group>
                        </Col>
                    :
                        <></>
                    }
                    {isAddingOrEditing === 'editing' && clientauth?.id !== state?._id ?
                        <Col xs={12} md={4}>
                            <Form.Label>{t('admin.user.userActive')}</Form.Label>
                            <div className="d-flex mt-2">
                                <Form.Check
                                    type="switch"
                                    id="active"
                                    label={state?.active ? <p className="pt-1 ps-2">{t("admin.user.enableda")}</p> : <p className="pt-1 ps-2">{t("admin.user.disableda")}</p>}
                                    name="active"
                                    checked={state.active || false}
                                    onChange={handleSwitchChange}
                                    className="mx-2 sd-switch"
                                />
                            </div>
                        </Col>
                    :
                        <></>
                    }
                </Row>
            :
                <></>
            }
            <Row>
                <Col xs={12} lg={6} className="my-2 ms-auto">
                    <Button variant='primary' type="submit" className="w-100 my-2">
                    {isRegistering ?
                        <>
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </>
                    :
                        isAddingOrEditing === 'editing' ?
                            <>{t('admin.user.edit')}</>
                        :
                            <>{t('admin.user.register')}</>
                    }
                    </Button>
                </Col>
            </Row>
        </Form>
    )
}